import { render } from "./ProviderActivities.vue?vue&type=template&id=3c52a3fc"
import script from "./ProviderActivities.vue?vue&type=script&lang=js"
export * from "./ProviderActivities.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__